import { render } from "./IntegrationSidebarComponent.vue?vue&type=template&id=2aa92670"
import script from "./IntegrationSidebarComponent.vue?vue&type=script&lang=js"
export * from "./IntegrationSidebarComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__